import React from "react"
import { css } from "@jsUtils"

import Styles from "./gridLines.module.scss"

/**
 * Eyebrow with colored line
 * @param {object} props - react props
 * @param {string} props.theme - dark or light
 * @param {string} props.className - class name
 */

const GridLines = props => {
  const { theme, className } = props
  return (
    <div
      className={css(
        Styles.gridLines,
        theme && Styles[`theme_${theme}`],
        className,
        `gridlinesIEOverride`
      )}
    >
      <div className={Styles.line} />
      <div className={Styles.line} />
    </div>
  )
}

export default GridLines
